(() => {
  const roots = document.querySelectorAll('[data-mv-pack-2026-root]');

  if (!roots.length) return;

  roots.forEach((root) => {
    const sectionId = root.dataset.sectionId || '';
    const cartUrl = root.dataset.cartUrl || '/cart';

    const emit = (name, detail = {}) => {
      root.dispatchEvent(
        new CustomEvent('mv-pack-2026:conversion', {
          bubbles: true,
          detail: {
            name,
            sectionId,
            ...detail,
          },
        })
      );
    };

    root.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const buyTrigger = target.closest('[data-mv-pack-2026-buy]');
      if (buyTrigger && root.contains(buyTrigger)) {
        emit('pack_click', {
          pack: buyTrigger.getAttribute('data-mv-pack-2026-buy'),
        });
      }

      const whatsappTrigger = target.closest('[data-mv-pack-2026-whatsapp]');
      if (whatsappTrigger && root.contains(whatsappTrigger)) {
        emit('whatsapp_click');
      }
    });

    root.addEventListener('submit', (event) => {
      const formComponent = event.target instanceof Element ? event.target.closest('product-form-component') : null;
      if (!formComponent || !root.contains(formComponent)) return;

      emit('cart_add_attempt', {
        pack: formComponent.getAttribute('data-mv-pack-2026-pack'),
        productId: formComponent.getAttribute('data-product-id'),
      });
    });

    root.addEventListener('cart:update', (event) => {
      const eventTarget = event.target instanceof Element ? event.target : null;
      const formComponent = eventTarget?.closest('product-form-component[data-mv-pack-2026-pack]');
      if (!formComponent || !root.contains(formComponent)) return;

      if (event.detail?.data?.didError) return;

      emit('cart_add_success', {
        pack: formComponent.getAttribute('data-mv-pack-2026-pack'),
        productId: formComponent.getAttribute('data-product-id'),
      });

      if (root.dataset.openCartAfterAdd !== 'true') return;

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        customElements.whenDefined('cart-drawer-component').then(() => {
          if (typeof drawer.open === 'function') drawer.open();
        });
        return;
      }

      window.location.href = cartUrl;
    });

    root.addEventListener('cart:error', (event) => {
      const eventTarget = event.target instanceof Element ? event.target : null;
      const formComponent = eventTarget?.closest('product-form-component[data-mv-pack-2026-pack]');
      if (!formComponent || !root.contains(formComponent)) return;

      emit('cart_add_error', {
        pack: formComponent.getAttribute('data-mv-pack-2026-pack'),
        productId: formComponent.getAttribute('data-product-id'),
      });
    });

    const pricing = root.querySelector('[data-mv-pack-2026-pricing]');
    if (pricing && 'IntersectionObserver' in window) {
      const pricingObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            emit('pricing_view');
            observer.disconnect();
          });
        },
        { threshold: 0.35 }
      );
      pricingObserver.observe(pricing);
    }

    root.querySelectorAll('[data-mv-pack-2026-faq]').forEach((item) => {
      const summary = item.querySelector('[data-mv-pack-2026-faq-summary]');
      if (!summary) return;

      summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');

      item.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
        if (item.open) {
          emit('faq_open', {
            question: summary.textContent?.trim() || '',
          });
        }
      });
    });

    const stickyCta = root.querySelector('[data-mv-pack-2026-sticky-cta]');
    const hero = root.querySelector('[data-mv-pack-2026-hero]');
    if (stickyCta && hero && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            stickyCta.toggleAttribute('data-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      stickyObserver.observe(hero);
    }
  });
})();
